import * as actionType from "../Actions/Action_Type";
import * as ROLES from "../Utils/Roles_Types.js";

const initialState = {
    isFetching        : false,
    errorMessage      : null,
    usernameError     : null,
    paypalConfig      : {
                            env      : 'sandbox', // you can set here to 'production' for production
                            client   : { sandbox: "Ac_XSSAkfV9jHSgAWpeAKzcKbRaIDmdr7n4MhADXyIBX5nrYI7LNEjKYBQEbquK03zxG7UkUzRVE5yre", production: "APP-80W284485P519543T" }
                        },
    paypalPriceList   : []
};

const registrazioneReducer = (state = initialState, action) => {
    switch (action.type){
        case actionType.SERVICE_CHECK_USERNAME_REQUEST :
            return Object.assign({}, state, {
            })
        case actionType.SERVICE_CHECK_USERNAME_SUCCESS :
            return Object.assign({}, state, {
                usernameError : null
            })
        case actionType.SERVICE_CHECK_USERNAME_ERROR :
            return Object.assign({}, state, {
                usernameError : action.error
            })
        case actionType.SERVICE_CHECK_EMAIL_REQUEST :
            return Object.assign({}, state, {
            })
        case actionType.SERVICE_CHECK_EMAIL_SUCCESS :
            return Object.assign({}, state, {
                userEmailError : null
            })
        case actionType.SERVICE_CHECK_EMAIL_ERROR :
            return Object.assign({}, state, {
                userEmailError : action.error
            })
        //PAYPAL CONFIG
        case actionType.SERVICE_PAYMENT_CONFIG_REQUEST :
            return Object.assign({}, state, {
            })
        case actionType.SERVICE_PAYMENT_CONFIG_SUCCESS :
            return Object.assign({}, state, {
                errorMessage : null,
                paypalConfig : action.config
            })
        case actionType.SERVICE_PAYMENT_CONFIG_ERROR :
            return Object.assign({}, state, {
                errorMessage : action.msgError
            })
        //PAYPAL PRICES
        case actionType.SERVICE_PAYMENT_PRICES_REQUEST :
            return Object.assign({}, state, {
            })
        case actionType.SERVICE_PAYMENT_PRICES_SUCCESS :
            return Object.assign({}, state, {
                errorMessage : null,
                paypalPriceList    : action.prices
            })
        case actionType.SERVICE_PAYMENT_PRICES_ERROR :
            return Object.assign({}, state, {
                errorMessage : action.msgError
            })
        default:
            return state;
    }
};

export default registrazioneReducer;


// WEBPACK FOOTER //
// ./src/Reducers/Reducer_Registrazione.js